import { render, staticRenderFns } from "./DepartmentModalForm.vue?vue&type=template&id=3d66598e"
import script from "./DepartmentModalForm.vue?vue&type=script&lang=js"
export * from "./DepartmentModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports